import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import firebase from "../firebase/credenciales.js";
import '../assets/style/main.css';
import '../assets/style/responsive.css';

// Importación de páginas con `lazy()`
const HomePage = lazy(() => import("../pages/home.js"));
const VenderPage = lazy(() => import("../pages/vender.js"));
const NosotrosPage = lazy(() => import("../pages/nosotros.js"));
const ComprarPage = lazy(() => import("../pages/comprar.js"));
const AlquilarPage = lazy(() => import("../pages/alquilar.js"));
const ContactoPage = lazy(() => import("../pages/contacto.js"));
const GraciasPage = lazy(() => import("../pages/gracias.js"));
const ComprarEspecialPage = lazy(() => import("../pages/comprarEspecial.js"));
const AlquilarEspecialPage = lazy(() => import("../pages/alquilarEspecial.js"));
const BlogPage = lazy(() => import("../pages/blog.js"));
const EntradaPage = lazy(() => import("../pages/entrada.js"));
const BusquedaPage = lazy(() => import("../pages/busqueda.js"));
const AdministracionPage = lazy(() => import("../pages/administracion.js"));
const AdministracioPropiedadesPage = lazy(() => import("../pages/administracion-propiedades.js"));
const ErrorPage = lazy(() => import("../pages/error.js"));

/**
 * Loader animado mientras las páginas cargan
 */
function Loader() {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 bg-gradient-to-r from-principal to-orange-500 rounded-full animate-spin"></div>
        <div className="absolute inset-1 bg-white rounded-full"></div> 
      </div>
    </div>
  );
}

function RoutesComponent() {
  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vender" element={<VenderPage />} />
          <Route path="/nosotros" element={<NosotrosPage />} />
          <Route path="/comprar" element={<ComprarPage />} />
          <Route path="/alquilar" element={<AlquilarPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
          <Route path="/gracias" element={<GraciasPage />} />
          <Route path="/comprar/*" element={<ComprarEspecialPage />} />
          <Route path="/alquilar/*" element={<AlquilarEspecialPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:url" element={<EntradaPage />} />
          <Route path="/:categoria/:categoria2/:termino" element={<BusquedaPage />} />
          <Route path="/administracion-iberpisos" element={<AdministracionPage />} />
          <Route path="/administracion-propiedades-iberpisos" element={<AdministracioPropiedadesPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default RoutesComponent;
